/*
 * @Date: 2024-03-11 16:20:25
 * @LastEditors: fangdong dong.fang@quvideo.com
 * @LastEditTime: 2024-03-11 16:20:27
 * @FilePath: /video-marketing/utils/cn.ts
 */
import clsx, { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

const cn = (...args: ClassValue[]) => twMerge(clsx(...args));

export { cn };
